import { useQuery, UseQueryResult } from "@tanstack/react-query"
import ResponseError from "../../../types/responseError"
import { carrotClient } from "#/utils/CarrotClient"
import { HttpStatusCodes } from "#/utils/HttpStatusCodes"
import { getBenefitCacheKey } from "../../dynamic-content/hooks/useGetBenefit"
import { Benefit } from "#/lib/carrot-api/types/Benefit"

export default function useGetMemberBenefit<TData = Benefit>(
  select?: (data: Benefit) => TData
): UseQueryResult<TData, ResponseError> {
  return useQuery<Benefit, ResponseError, TData>(getBenefitCacheKey(), () => carrotClient.getBenefit(), {
    retry: (failureCount, error) => {
      switch (error.statusCode) {
        case HttpStatusCodes.UNAUTHORIZED:
        case HttpStatusCodes.BAD_REQUEST:
        case HttpStatusCodes.NOT_FOUND:
          return false
        default:
          return failureCount <= 3
      }
    },
    select
  })
}
